module.exports = __webpack_public_path__ + "static/media/elegant.11444505.png";